import { render, staticRenderFns } from "./recordAdd.vue?vue&type=template&id=27e8e9ec"
import script from "./recordAdd.vue?vue&type=script&lang=js"
export * from "./recordAdd.vue?vue&type=script&lang=js"
import style0 from "./recordAdd.vue?vue&type=style&index=0&id=27e8e9ec&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports